import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Button, Divider, Row, Space } from 'antd'
import PropTypes from 'prop-types'

import { GridFormItem } from '../../../core/components/sections'

import { StyledPaddingTopCol } from '../../../common/components/styled'

import { UnknownWordsButtons } from '../../../unknown-words/components/sections'
import { LABEL_LEGEND_TYPE } from '../../constants'
import { useUpdateMenuCurationTaskMutation } from '../../hooks'
import { menuCurationTaskPropType } from '../../prop-types'
import { transformMenuCurationTaskFormValuesToUpdateArgs } from '../../transformers'

import LabelLegends from './label-legends'

const MenuCurationTaskLabelLegends = ({ menuCurationTask, isDisabled }) => {
  const { dietLabelLegends, allergenLabelLegends } = menuCurationTask
  const [labelLegendsValue, setLabelLegendsValue] = useState({})
  const [isDirty, setIsDirty] = useState(false)

  const { dietOptions, allergenOptions } = useSelector(
    store => store.common.metadata.data,
  )

  const [updateMenuCurationTask, { isUpdateLoading }] =
    useUpdateMenuCurationTaskMutation()

  useEffect(() => {
    setLabelLegendsValue({
      dietLabelLegends,
      allergenLabelLegends,
    })
    setIsDirty(false)
  }, [allergenLabelLegends, dietLabelLegends])

  const handleAllergenChange = useCallback(
    newValue => {
      setLabelLegendsValue({
        ...labelLegendsValue,
        allergenLabelLegends: newValue,
      })
      setIsDirty(true)
    },
    [labelLegendsValue],
  )

  const handleDietChange = useCallback(
    newValue => {
      setLabelLegendsValue({
        ...labelLegendsValue,
        dietLabelLegends: newValue,
      })
      setIsDirty(true)
    },
    [labelLegendsValue],
  )

  const handleReset = useCallback(() => {
    setLabelLegendsValue({
      dietLabelLegends,
      allergenLabelLegends,
    })
    setIsDirty(false)
  }, [allergenLabelLegends, dietLabelLegends])

  const handleSave = useCallback(() => {
    updateMenuCurationTask(
      menuCurationTask.id,
      transformMenuCurationTaskFormValuesToUpdateArgs(labelLegendsValue),
    )
  }, [labelLegendsValue, menuCurationTask.id, updateMenuCurationTask])

  return (
    <>
      <Row gutter={16}>
        <UnknownWordsButtons />
        <GridFormItem span={5} label="Diet label legend">
          <LabelLegends
            labelLegends={labelLegendsValue.dietLabelLegends}
            type={LABEL_LEGEND_TYPE.DIET}
            isDisabled={isDisabled}
            options={dietOptions}
            onChange={handleDietChange}
            showAddButton
          />
        </GridFormItem>
        <GridFormItem span={5} label="Allergen label legend">
          <LabelLegends
            labelLegends={labelLegendsValue.allergenLabelLegends}
            type={LABEL_LEGEND_TYPE.ALLERGEN}
            isDisabled={isDisabled}
            options={allergenOptions}
            onChange={handleAllergenChange}
            showAddButton
          />
        </GridFormItem>
        {isDirty && (
          <StyledPaddingTopCol span={4}>
            <Space>
              <Button htmlType="button" ghost danger onClick={handleReset}>
                Cancel
              </Button>

              <Button
                type="primary"
                onClick={handleSave}
                disabled={isUpdateLoading}
              >
                Save
              </Button>
            </Space>
          </StyledPaddingTopCol>
        )}
      </Row>
      <Divider />
    </>
  )
}

MenuCurationTaskLabelLegends.propTypes = {
  menuCurationTask: menuCurationTaskPropType.isRequired,
  isDisabled: PropTypes.bool,
}

MenuCurationTaskLabelLegends.defaultProps = {
  isDisabled: false,
}

export default MenuCurationTaskLabelLegends
